import { inject, Injectable } from '@angular/core';
import { ColumnState } from 'ag-grid-enterprise';
import { StorageService } from 'ngx-lib';

interface ILocalStorageState {
    colId: string;
    hide: boolean;
    width: number;
}
@Injectable()
export class GridStorageService {
    private readonly storageService = inject(StorageService);
    private readonly storageKeyPrefix = 'grid-columns-';

    getGridState(key: string): ColumnState[] | undefined {
        const fullKey = this.generateKey(key);
        return this.storageService.getItem<ILocalStorageState[]>(fullKey);
    }

    setGridState(key: string, state: ColumnState[]): void {
        const fullKey = this.generateKey(key);
        const currentState = this.getGridState(key);

        const serializedState = JSON.stringify(this.formatToLocalStorage(state));
        const serializedPrevious = JSON.stringify(this.formatToLocalStorage(currentState ?? []));

        if (serializedState === serializedPrevious) {
            return;
        }

        const localStorageState = this.formatToLocalStorage(state);
        this.storageService.setItem(fullKey, localStorageState);
    }

    formatToLocalStorage(columnState: ColumnState[]): ILocalStorageState[] {
        return columnState.map((col) => ({
            colId: col.colId,
            hide: !!col.hide,
            width: col.width || 200
        }));
    }

    generateKey(key: string) {
        return `${this.storageKeyPrefix}${key}`;
    }
}
